module.exports = __webpack_public_path__ + "img/debbie.712663b7.jpg";